import { router } from '../actions';
import { STATES } from '../../constants';

const MOVEIQ_SHOULD_SEE_SURVEY = 'MOVEIQ_SHOULD_SEE_SURVEY';
const MOVEIQ_DESIRED_TO_STATE = 'MOVEIQ_DESIRED_TO_STATE';
const DIY_CONVERSION = 'DIY_CONVERSION';
const MOVEIQ_SAW_SURVEY = 'MOVEIQ_SAW_SURVEY';
const MOVEIQ_BACK_STATE = 'MOVEIQ_BACK_STATE';

const MOVEIQ_SURVEY_PATH = 'survey';

export const actions = {
  shouldSeeSurvey: payload => ({
    type: MOVEIQ_SHOULD_SEE_SURVEY,
    payload,
  }),
  desiredToState: payload => ({
    type: MOVEIQ_DESIRED_TO_STATE,
    payload,
  }),
  diyConversion: payload => ({
    type: DIY_CONVERSION,
    payload,
  }),
  sawSurvey: payload => ({
    type: MOVEIQ_SAW_SURVEY,
    payload,
  }),
  backState: payload => ({
    type: MOVEIQ_BACK_STATE,
    payload,
  }),
};

export function reducer(state = {}, action) {
  if (action.type === MOVEIQ_SHOULD_SEE_SURVEY) {
    return {
      ...state,
      shouldSeeSurvey: action.payload,
    };
  }
  if (action.type === MOVEIQ_DESIRED_TO_STATE) {
    return {
      ...state,
      desiredToState: action.payload,
    };
  }
  if (action.type === DIY_CONVERSION) {
    return {
      ...state,
      diyConverted: action.payload,
    };
  }
  if (action.type === MOVEIQ_SAW_SURVEY) {
    return {
      ...state,
      sawSurvey: action.payload,
    };
  }
  if (action.type === MOVEIQ_BACK_STATE) {
    return {
      ...state,
      backState: action.payload,
    };
  }
  return state;
}

const SURVEY_CURRENT_BLACKLIST = [STATES.STEP_MOVEIQ, STATES.STEP_DIY_MOVE];
const SURVEY_PREVIOUS_WHITELIST = [STATES.STEP_MOVEIQ, STATES.STEP_DIY_MOVE];

const BACK_CURRENT_WHITELIST = [STATES.STEP_MOVEIQ];
// Diy is still "in move your stuff" so shouldn't be considered a back state
const BACK_PREVIOUS_BLACKLIST = [STATES.STEP_DIY_MOVE];

export function epic() {
  return (action, { dispatch, getState }) => {
    const { shouldSeeSurvey, sawSurvey } = getState().moveiq || {};

    if (
      action.type === '@@reduxUiRouter/$stateChangeSuccess' &&
      !SURVEY_CURRENT_BLACKLIST.includes(action.payload.currentState.name) &&
      SURVEY_PREVIOUS_WHITELIST.includes(action.payload.prevState.name) &&
      shouldSeeSurvey &&
      !sawSurvey
    ) {
      dispatch(actions.shouldSeeSurvey(false));
      dispatch(actions.sawSurvey(true));
      dispatch(
        actions.desiredToState({
          name: action.payload.currentState.name,
          params: action.payload.currentParams,
        })
      );
      dispatch(
        router.stateGo(STATES.STEP_MOVEIQ, { path: MOVEIQ_SURVEY_PATH })
      );
    }

    if (
      action.type === '@@reduxUiRouter/$stateChangeSuccess' &&
      BACK_CURRENT_WHITELIST.includes(action.payload.currentState.name) &&
      !BACK_PREVIOUS_BLACKLIST.includes(action.payload.prevState.name)
    ) {
      dispatch(
        actions.backState({
          name: action.payload.prevState.name,
          params: action.payload.prevParams,
        })
      );
    }
  };
}
